var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#7356BF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19021_188322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.54488 5.45498C8.53988 4.44998 7.03488 4.24498 5.82488 4.83498L7.63988 6.64998C7.83488 6.84498 7.83488 7.15998 7.63988 7.35498L6.84488 8.14998C6.64988 8.34998 6.33488 8.34998 6.13988 8.14998L4.32488 6.33498C3.73988 7.54998 3.94488 9.04498 4.94988 10.05C5.87988 10.98 7.23988 11.225 8.39488 10.79L12.3749 14.77C12.8899 15.285 13.7199 15.285 14.2299 14.77C14.7449 14.255 14.7449 13.425 14.2299 12.915L10.2699 8.94998C10.7299 7.77998 10.4899 6.39998 9.54488 5.45498Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19021_188322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(3.5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.d05e4d51c64e523094f5b9f70be44e3c.svg";
export { ForwardRef as ReactComponent };